import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TableContainer, Paper } from '@mui/material';
import axios, { decryptData } from '../Axiosinstance';
import './Manage.css';
import CourseCompletion from '../components/CourseCompletion';
import Certificate from '../components/Certificate';
import MarkCertificate from '../components/MarkCertificate';
import { buttonBackgroundColor } from '../common';

const Green = () => {
    const { batchId, intakeId } = useParams();
    const batchId1 = decryptData(decodeURIComponent(batchId));
    const intakeId1 = decryptData(decodeURIComponent(intakeId));

    const [students, setStudents] = useState([]);
    const [externalStudents, setExternalStudents] = useState([]);
    const [studentNames, setStudentNames] = useState([]);
    const courseCompletionRef = useRef(null);
    const certificateRef = useRef(null);
    const markCertificateRef = useRef(null);

    const marksheetRef = useRef([]);  // Ref to store the marksheet data

    useEffect(() => {
        fetchDataFromAPI();
        fetchExternalDataFromAPI();
    }, [intakeId1]);

    const fetchDataFromAPI = async () => {
        try {
            const response = await axios.get('manages');
            const allStudents = response.data;
            const filteredStudents = allStudents.filter(student => student.batch_id === parseInt(batchId1));
            setStudents(filteredStudents);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchExternalDataFromAPI = async () => {
        try {
            const response1 = await axios.get(`/registrationadvances/registration/active?intakeId=${intakeId1}`);
            const externalData = response1.data;
            setExternalStudents(externalData);
            const studentsArray = externalData.reverse().map(student => ({
                id: student.id,   // Store student ID
                name: student.name,
                approver: student.approver,
            }));
            console.log("zcccc:", studentsArray)
            setStudentNames(studentsArray);
        } catch (error) {
            console.error('Error fetching external data:', error);
        }
    };

    const fetchMarksheetData = async (student, studentNames) => {
        try {
            const response = await axios.get(`intake/${student.intakeId}`);
            marksheetRef.current = response.data;  // Store marksheet data in the ref
            handleMarkCertificate(student, studentNames);  // Trigger marksheet generation
        } catch (error) {
            console.error('Error fetching marksheet data:', error);
        }
    };

    // Pagination logic
    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(5);

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };

    // const paginatedStudents = externalStudents.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handleCourseCompletion = (student) => {
        if (courseCompletionRef.current) {
            courseCompletionRef.current.handleDownload(student); // Pass student-specific data
        }
    };

    const handleCertificate = (student, studentNames) => {
        if (certificateRef.current) {
            certificateRef.current.handleDownload(student, studentNames); // Pass student-specific data
        }
    };
    const handleMarkCertificate = (student, studentNames) => {
        if (markCertificateRef.current) {
            markCertificateRef.current.handleDownload(student, studentNames); // Pass student-specific data directly
        }
    };

    const maskNRIC_FIN = (value) => {
        if (!value) return "";
        return value.slice(0, -4).replace(/\w/g, "*") + value.slice(-4);
    };

    return (
        <div className='container-responsive' >

            {/* Table for displaying students */}
            <TableContainer component={Paper} style={{
                boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                borderRadius: '8px',
                maxHeight: '500px',  // Set a max height for the container
                overflowY: 'auto'   // Enable vertical scrolling for the table body
            }}>                <Table sx={{ width: '1290px' }}>
                    <TableHead>
                        <TableRow style={{
                            backgroundColor: '#f5f5f5',
                            position: 'sticky',
                            top: 0,
                            zIndex: 1 // Ensure it stays above the table body when scrolling
                        }}>                        <TableCell style={{ fontWeight: 'bold' }}>S.No</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Student Name</TableCell>
                            {/* <TableCell>Email</TableCell> */}
                            <TableCell style={{ fontWeight: 'bold' }}>Intake Id</TableCell>
                            {/* <TableCell>Phone Number</TableCell> */}
                            <TableCell style={{ fontWeight: 'bold' }}>NRIC/FIN</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Enroll Date</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Course Completion</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Certificate</TableCell>
                            <TableCell style={{ fontWeight: 'bold' }}>Marksheets</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {externalStudents.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={7} align="center">
                                    Loading...
                                </TableCell>
                            </TableRow>
                        ) : (
                            externalStudents.map((student, index) => (
                                <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{student.name.toUpperCase()}</TableCell>
                                    {/* <TableCell>{student.email}</TableCell> */}
                                    <TableCell>{student.intakeId}</TableCell>
                                    {/* <TableCell>{student.handPhone}</TableCell> */}
                                    {/* <TableCell>{student.nric}</TableCell> */}
                                    <TableCell>{(student.nric)}</TableCell>
                                    <TableCell>{new Date(student.enrolledDate).toLocaleDateString("en-GB")}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleCourseCompletion(student)}
                                            style={{backgroundColor: buttonBackgroundColor, color:'white'}}

                                        >
                                            Course Completion
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => handleCertificate(student, studentNames)}
                                            style={{backgroundColor: buttonBackgroundColor, color:'white'}}
                                        >
                                            Certificate
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => fetchMarksheetData(student, studentNames)} 
                                            style={{backgroundColor: buttonBackgroundColor, color:'white'}}
                                        >
                                            MarkSheet
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
                {/* <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={externalStudents.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
            </TableContainer>

            {/* CourseCompletion and Certificate handling */}
            <div style={{ marginTop: '20px' }}>
                <CourseCompletion ref={courseCompletionRef} dataProp={externalStudents} />
                <Certificate ref={certificateRef} dataProp={externalStudents} studentInfo={students} />
                <MarkCertificate ref={markCertificateRef} dataProp={externalStudents} studentInfo={students} />
            </div>
        </div>
    );
};

export default Green;
